module.exports = __webpack_public_path__ + "img/BikeNow.95ebea80.svg";